import { formatCurrency, formatInteger, formatDecimal, formatCompact, currencyDecimals } from './numberFormat'

// Project-specific glue lives here so numberFormat.js stays portable across repos.

// Locale = browser language (project requirement); 'es-CL' as last-resort fallback.
const resolveLocale = () => navigator.language || 'es-CL'

const fmt = {
  currency: (currency, amount) => formatCurrency(resolveLocale(), currency, amount),
  integer: (amount) => formatInteger(resolveLocale(), amount),
  decimal: (amount, decimals) => formatDecimal(resolveLocale(), amount, decimals),
  compact: (amount, decimals) => formatCompact(resolveLocale(), amount, decimals),
  currencyDecimals: (currency) => currencyDecimals(resolveLocale(), currency)
}

export default {
  install (Vue) {
    Vue.prototype.$fmt = fmt
  }
}
